define('views/invite/invitationlist',[
    "backbone",
    "text!views/invite/invitationlist.html",
    "views/_base/baseview",
    "models/invite/invite",
    "views/invite/invite",
    "views/invite/invitationitem",
    "views/shared/modal/modal_modern"
], function (Backbone, Template, BaseView, InviteModel, Invite, InviteItem, Modal) {
    "use strict";

    return BaseView.extend({
        template  : _.template(Template),
        id        : 'invite-ff-list',
        tagName   : "div",
        isRender  : false,
        needsAuth : true,
        events    : {
            'click .js-invite-ff-btn': 'showFfForm'
        },
        initialize: function(options){
            options = options || {};
            this.elementName = options.elementName;
            this.showList = false;
            BaseView.prototype.initialize(this);
        },

        loadData: function(){
            var that = this;
            this.invite_list_model = new InviteModel();
            this.invite_list_model.fetch().done(function(resp){

                if(resp.length){
                    // that.showList = true;
                    that.render();
                    that.addAll(resp);
                } else {
                    // that.showList = false;
                    that.render();
                }
                
            }).fail(function(err){});
            
            this.$('.js-invite-ff-btn').on('click',this.showFfForm);
            this.$('.spinner').addClass('hidden');
        },

        render: function(){
            var that = this;

            // Check list endpoint, if there is no invitations then show invite button
            this.$el.html(this.template());

            // TODO: Fix this, shouldn't need a timeout to show the spinner
            // setTimeout(function(){
            //     that.$('.spinner').removeClass('hidden');
            // },300);

            this.cleanUpTemplate();

            return this;
        },

        addOne: function(person){
            var invite_html = new InviteItem({ person: {
                firstName : person.FN,
                lastName  : person.LN,
                invitedDT : person.IDT,
                acceptedDT: person.ADT
            } }).$el.html();
            this.$('.js-invitation-list').append(invite_html);
        },

        addAll: function(resp){
            for(var i = 0; i < resp.length; i++){
                var person = resp[i];
                this.addOne(person);
            }

            this.$('.spinner').addClass('hidden');
        },

        showFfForm: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            // Show Friends & Family Form within a modal
            var invite_view = new Invite(),
                modal = new Modal({
                    show        : true, // True, if we want the modal to show itself when it's ready
                    title       : 'Invite Friends & Family',
                    content     : invite_view.$el.html(),
                    calling_view: invite_view // Send in corresponding view to inherit events and custom properties
                });
        },

        cleanUpTemplate: function(){
            if(this.showList){
                this.$('.js-invitation-button-container').remove();
            } else {
                this.$('.js-invitation-list-container').remove();
            }
        },

        close: function(){}
    });
});

